// Libraries
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

export const StyledButton = styled(motion.button).attrs(props => ({ type: 'submit' }))`
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  width: 421px;
  height: 70px;
  margin: 0 0 10px 0;
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 28px;
  line-height: 38px;
  border: none;
  color: #fff;
  background-color: #ea3639;
  box-shadow: 8px 8px 8px rgba(36, 36, 36, 0.4);
  z-index: 1;
  user-select: none;
  :hover {
    background-color: #ec080b;
    cursor: pointer;
  }
  :active {
    background-color: #ec080b;
  }
  ${({theme}) => css`
    ${theme.media.tablet} {
      width: 100%;
    }
  `}
`;

export const Arrow = styled(motion.img)`
  margin-left: 10px;
  ${({theme}) => css`
    ${theme.media.mobileS} {
      margin-right: 3px;
    }
  `}
`;
